import { isDevelopment } from '$lib/utils/environmentResolver';
import { browser } from '$app/environment';
import { page } from '$app/stores';
import { get } from 'svelte/store';

const reDataUri = /^data:/;

export const getCloudinaryUrl = () => {
	//TODO: This should have been solved with a public env variable
	let pod: string;
	if (browser) {
		pod = get(page)?.data?.pod || 'dev';
	} else {
		pod = process.env.POD || 'dev';
	}
	if (isDevelopment(pod)) {
		return 'https://qa-assets.visioncritical.net/image';
	} else {
		return 'https://assets.visioncritical.net/image';
	}
};

// List of available transformations
// https://cloudinary.com/documentation/image_transformation_reference#quality_parameter
export default function toCloudinaryUrl(
	url: null | string,
	width: number | string,
	height: number | string,
	op?: string,
	cloudinaryTransformationParam?: string,
	box?: Array<number>,
	crop?: string,
	radius?: number,
	angle?: number,
	effect?: string,
	quality?: string | number,
	opacity?: number,
	format?: string
): null | string {
	let transformations = cloudinaryTransformationParam
		? cloudinaryTransformationParam
		: 'c_fill,q_auto,';
	const isBox: boolean | undefined = box && box.length > 0;

	if (!url) return null;

	// Check if url is data-uri
	if (reDataUri.test(url)) return url;

	if (width) {
		transformations = transformations.concat(`w_${width},`);
	}

	if (height) {
		transformations = transformations.concat(`h_${height},`);
	}

	if (op === 'contain') {
		transformations = transformations.concat(`c_fit,`);
	}

	if (!isBox && op === 'balance') {
		transformations = transformations.concat(`g_auto,`);
	}

	if (crop) {
		transformations = transformations.concat(`c_${crop},`);
	}

	if (radius) {
		transformations = transformations.concat(`r_${radius},`);
	}

	if (angle) {
		transformations = transformations.concat(`a_${angle},`);
	}

	if (effect) {
		transformations = transformations.concat(`e_${effect},`);
	}

	if (opacity) {
		transformations = transformations.concat(`o_${opacity},`);
	}

	if (quality) {
		transformations = transformations.concat(`q_${quality},`);
	}

	if (box && box.length > 0) {
		const x: number = box[0];
		const y: number = box[1];
		const w: number = box[2] - box[0];
		const h: number = box[3] - box[1];
		transformations = transformations.concat(
			`x_${x},y_${y},w_${w},h_${h},c_crop/w_auto,h_${height},`
		);
	}

	transformations = transformations.concat(`f_${format ? format : `auto`}`);
	return `${getCloudinaryUrl()}/fetch/${transformations}/${url}`;
}
